<form class="form-popup" [formGroup]="formGroup">

  <mat-form-field appearance="fill">
      <mat-label>Drum Number</mat-label>
      {{ drumToEdit.wasteDrumNumber.substring(0,7) }}
      <input
          matInput
          name="Drum Number"
          autocomplete="off"
          formControlName="wasteDrumNumberLastFive"
          maxlength="5" minlength="5"
          />
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Container Type</mat-label>
      <mat-select
        formControlName="containerTypeId"
        class="fullWidth"
        name="Container Type" >
        <mat-option *ngFor="let c of wasteContainerTypes | async " [value]="c.containerTypeId">
          {{ c.containerTypeDescription }}
        </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Waste Type</mat-label>
      <mat-select
        formControlName="wasteTypeId"
        class="fullWidth"
        name="Waste Type" >
        <mat-option *ngFor="let w of wasteTypes | async " [value]="w.wasteTypeId">
                  {{ w.wasteType }}
        </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Site</mat-label>
      <mat-select
        formControlName="siteId"
        class="fullWidth"
        (selectionChange)="updateWasteDrumNumberSite($event)"
        name="Site" >
        <mat-option *ngFor="let s of sites" [value]="s.siteId">
          {{ s.siteName }}
        </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Issued Date</mat-label>
    <input
        name="Issued Date"
        matInput
        [matDatepicker]="picker1"
        formControlName="issuedDate"
        autocomplete="off"
        >
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Off-Site Date</mat-label>
    <input
        name="Off-Site Date"
        matInput
        [matDatepicker]="picker2"
        formControlName="offSiteDate"
        autocomplete="off"
        >
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Accumulation Date</mat-label>
    <input
        name="Accumulation Date"
        matInput
        [matDatepicker]="picker3"
        formControlName="accumulationDate"
        autocomplete="off"
        (dateChange)="updateAccumDate($event.value)"
        >
    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
    <mat-datepicker #picker3></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Issued By</mat-label>
    <mat-select
      formControlName="issuedById"
      class="fullWidth"
      name="Issued By" >
      <mat-option *ngFor="let e of emps" [value]="e.employeeId">
        {{ e.fullName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Status</mat-label>
    <mat-select
      formControlName="wasteCurrentStatusId"
      class="fullWidth"
      name="Status" >
      <mat-option *ngFor="let w of wasteStati  | async" [value]="w.wasteCurrentStatusId">
        {{ w.wasteCurrentStatus }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Sealed Date</mat-label>
    <input
        name="Sealed Date"
        matInput
        [matDatepicker]="picker4"
        formControlName="sealedDate"
        autocomplete="off"
        >
    <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
    <mat-datepicker #picker4></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Sealed By</mat-label>
    <mat-select
      formControlName="sealedById"
      class="fullWidth"
      name="Sealed By" >
      <mat-option *ngFor="let e of emps" [value]="e.employeeId">
        {{ e.fullName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Closed-Out Date</mat-label>
    <input
        name="Closed-Out Date"
        matInput
        [matDatepicker]="picker5"
        formControlName="closedOutDate"
        autocomplete="off"
        >
    <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
    <mat-datepicker #picker5></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Closed-Out By</mat-label>
    <mat-select
      formControlName="closedOutById"
      class="fullWidth"
      name="Closed-Out By" >
      <mat-option *ngFor="let e of emps" [value]="e.employeeId">
        {{ e.fullName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

</form>
